import React from 'react';
import { motion } from 'framer-motion';
import { Brain, Target, Cpu } from 'lucide-react';
export function TransformSection() {
  const pillars = [{
    title: 'Mentalidad',
    description: 'Aprender a pensar de forma diferente y eliminar creencias que bloquean tu crecimiento.',
    icon: <Brain className="w-8 h-8 text-purple-400" data-id="element-169" />,
    bgClass: 'bg-purple-500/20',
    borderClass: 'border-white/10'
  }, {
    title: 'Hábitos',
    description: 'Construir rutinas y acciones diarias que te acerquen a tus objetivos.',
    icon: <Target className="w-8 h-8 text-pink-400" data-id="element-170" />,
    bgClass: 'bg-pink-500/20',
    borderClass: 'border-white/10'
  }, {
    title: 'Inteligencia Artificial',
    description: 'Usar nuevas herramientas tecnológicas para acelerar resultados.',
    icon: <Cpu className="w-8 h-8 text-blue-400" data-id="element-171" />,
    bgClass: 'bg-blue-500/20',
    borderClass: 'border-white/10'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-slate-950 via-purple-950/30 to-slate-950" data-id="element-172">
      <div className="max-w-7xl mx-auto text-center" data-id="element-173">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-16" data-id="element-174">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6" data-id="element-175">
            La transformación empieza en tu mente.
          </h2>
          <p className="text-xl text-slate-400 max-w-2xl mx-auto" data-id="element-176">
            Antes de crear resultados afuera, necesitas crear claridad adentro.
            Por eso este sistema trabaja tres pilares fundamentales:
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-177">
          {pillars.map((pillar, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className={`p-8 rounded-3xl border ${pillar.borderClass} bg-white/[0.06] backdrop-blur-sm shadow-xl shadow-black/20 hover:-translate-y-2 transition-transform duration-300`} data-id="element-178">
              <div className={`w-16 h-16 rounded-2xl ${pillar.bgClass} flex items-center justify-center mb-6 mx-auto`} data-id="element-179">
                {pillar.icon}
              </div>
              <h3 className="text-2xl font-bold text-white mb-4" data-id="element-180">
                {pillar.title}
              </h3>
              <p className="text-slate-400 leading-relaxed" data-id="element-181">
                {pillar.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}